export class SmartTagModel {
	smartTagObjectId?: string;
	tagType?: string;
	title?: string;
	description?: string;
	subCategory?: string;
	isVisible?: boolean;
	isOutside?: string;
	additionalData?: any[];
	groupName?: string;
	_Path?: string;
	error?: SmartTagErrorModel;
}

export class SmartTagErrorModel {
	succeed?: boolean;
	message?: string;

	constructor() {
		this.succeed = null;
		this.message = 'Error, contact support.';
	}
}
